/* =====================================================
   3-step-custom-form-v2-freebies.js — FREEBIE FORK

   Identical to 3-step-custom-form-v2.js EXCEPT for ONE behavioral change:
   the progress bar is offset by +1 because /pages/commencer-offre has
   FOUR progress steps (Personnalisation, Quantité, Plan, Paiement) instead
   of three (Quantité, Plan, Paiement).

   The form itself still has only 2 form-steps (#step-1 cat count and
   #step-2 plan), exactly like the original. The customer enters at
   form-step 1 which now corresponds to progress-step 2 (Quantité);
   form-step 2 corresponds to progress-step 3 (Plan); checkout submission
   advances to progress-step 4 (Paiement).

   The OFFSET is applied ONLY in goToStep()'s progress-bar update loop —
   see the marked block below. Everything else is byte-identical to the
   original so any future bugfix landed in 3-step-custom-form-v2.js can be
   ported here mechanically.
   ===================================================== */

// ── Funnel tracking: capture URL parameter on page load ──
(function() {
  var urlParams = new URLSearchParams(window.location.search);
  var funnelSource = urlParams.get('funnel');
  if (funnelSource) {
    sessionStorage.setItem('funnel_source', funnelSource);
  }
})();

// ── Pricing data (hardcoded — does not change via CMS) ──
const catData = {
  1: {
    monthly: 24, quarterly: 67, fullMonthly: 72, savings: 5,
    plan3Detail: '3 sacchi ogni 12 settimane',
    plan1Detail: '1 sacco ogni 4 settimane',
    plan1Price: '24\u20AC'
  },
  2: {
    monthly: 44, quarterly: 122, fullMonthly: 132, savings: 10,
    plan3Detail: '6 sacchi ogni 12 settimane',
    plan1Detail: '2 sacchi ogni 4 settimane',
    plan1Price: '44\u20AC'
  },
  3: {
    monthly: 66, quarterly: 183, fullMonthly: 198, savings: 15,
    plan3Detail: '9 sacchi ogni 12 settimane',
    plan1Detail: '3 sacchi ogni 4 settimane',
    plan1Price: '66\u20AC'
  }
};

let selectedCats = 1;
let selectedPlan = '3mois';
let currentStep = 1;

// ── DOM references (set after DOMContentLoaded) ──
var v2Form, v2FormCard;

// =====================================================
//  ORIGINAL CHECKOUT LOGIC — variant/selling-plan reads
// =====================================================

/**
 * selectOption — called via onclick on .option cards (cat cards in step 1).
 * Keeps the original combinaison-key system intact.
 */
function selectOption(optionSelected, step_number) {
  var container = document.querySelector('.v2-page-wrapper:not(.v2bis-page-wrapper) .form-card');
  container.querySelectorAll('.form-step[data-step="' + step_number + '"] .option').forEach(function(option) {
    option.classList.remove('active');
  });
  optionSelected.classList.add('active');
  updateCurrentSelectedOffer();
}

/**
 * Read active .option cards from step1 + step2,
 * combine their combinaison keys, and set the matching .issue span to active.
 */
function updateCurrentSelectedOffer() {
  var activeOptions = document.querySelectorAll('.v2-page-wrapper:not(.v2bis-page-wrapper) .option.active');
  if (activeOptions.length < 2) return;
  var first_key = activeOptions[0].dataset.combinaisonKey;
  var second_key = activeOptions[1].dataset.combinaisonKey;
  document.querySelectorAll('.v2-page-wrapper:not(.v2bis-page-wrapper) .issue').forEach(function(issue) {
    if (issue.dataset.combinaisonKey === first_key + second_key) {
      issue.classList.add('active');
    } else {
      issue.classList.remove('active');
    }
  });
}

function getCurrentSelectedOfferID() {
  var el = document.querySelector('.v2-page-wrapper:not(.v2bis-page-wrapper) .issue.active');
  return el ? parseInt(el.dataset.variantId) : null;
}

function getCurrentSelectedOfferPlanID() {
  var el = document.querySelector('.v2-page-wrapper:not(.v2bis-page-wrapper) .issue.active');
  return el ? parseInt(el.dataset.sellingplanId) : null;
}

// =====================================================
//  POPUP
// =====================================================

var _popupPreviousFocus = null;

function showPopup() {
  _popupPreviousFocus = document.activeElement;
  var overlay = document.getElementById('v2-popup-overlay');
  overlay.classList.add('visible');
  // Move focus to first actionable button inside popup
  var firstBtn = overlay.querySelector('.popup-btn-keep');
  if (firstBtn) setTimeout(function() { firstBtn.focus(); }, 100);
}

function closePopup() {
  document.getElementById('v2-popup-overlay').classList.remove('visible');
  // Return focus to element that triggered the popup
  if (_popupPreviousFocus) {
    _popupPreviousFocus.focus();
    _popupPreviousFocus = null;
  }
}

// ESC key closes popup
document.addEventListener('keydown', function(e) {
  if ((e.key === 'Escape' || e.keyCode === 27) && document.getElementById('v2-popup-overlay').classList.contains('visible')) {
    closePopup();
  }
});

// Focus trap inside popup
document.addEventListener('keydown', function(e) {
  if (e.key !== 'Tab' && e.keyCode !== 9) return;
  var overlay = document.getElementById('v2-popup-overlay');
  if (!overlay || !overlay.classList.contains('visible')) return;
  var modal = overlay.querySelector('.popup-modal');
  var focusable = modal.querySelectorAll('button, [href], input, [tabindex]:not([tabindex="-1"])');
  if (focusable.length === 0) return;
  var first = focusable[0];
  var last = focusable[focusable.length - 1];
  if (e.shiftKey) {
    if (document.activeElement === first) { e.preventDefault(); last.focus(); }
  } else {
    if (document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
});

/**
 * "Choisir le plan 3 mois" button in popup:
 * 1. Select the 3mois option
 * 2. Update active classes + combinaison
 * 3. Proceed to checkout
 */
function takeOffer() {
  closePopup();
  selectedPlan = '3mois';
  applyPlanUI();
  // FIX R1: sync radio buttons so 1mois remains clickable if checkout fails
  var radio3 = document.getElementById('plan-radio-3mois');
  var radio1 = document.getElementById('plan-radio-1mois');
  if (radio3) radio3.checked = true;
  if (radio1) radio1.checked = false;
  // Click the 3mois hidden .option to update combinaison
  var plan3Option = document.querySelector('.v2-page-wrapper:not(.v2bis-page-wrapper) .option[data-combinaison-key="3mois"]');
  if (plan3Option) {
    plan3Option.classList.add('active');
    // Remove active from 1mois option
    var plan1Option = document.querySelector('.v2-page-wrapper:not(.v2bis-page-wrapper) .option[data-combinaison-key="1mois"]');
    if (plan1Option) plan1Option.classList.remove('active');
    updateCurrentSelectedOffer();
  }
  doCheckout();
}

/**
 * "Continuer avec le plan mensuel" button in popup:
 * Close popup — 1mois is already selected (Test #3 behavior).
 */
function continue1Month() {
  closePopup();
  // 1mois stays selected, user can click Paiement again to proceed
}

function checkoutWithNoUpsell() {
  doCheckout();
}

var _checkoutInProgress = false;

// Reset checkout lock when page is restored from bfcache (user clicks back from /checkout)
window.addEventListener('pageshow', function(e) {
  _checkoutInProgress = false;
});

function doCheckout() {
  // FIX Bug#5: prevent double-click triggering parallel cart operations
  if (_checkoutInProgress) return;
  _checkoutInProgress = true;

  var variantId = getCurrentSelectedOfferID();
  var sellingPlanId = getCurrentSelectedOfferPlanID();
  if (!variantId || isNaN(variantId)) {
    _checkoutInProgress = false;
    alert('Erreur : produit non trouvé. Veuillez rafraîchir la page et réessayer.');
    return;
  }
  if (!sellingPlanId || isNaN(sellingPlanId)) {
    _checkoutInProgress = false;
    alert('Erreur : abonnement non trouvé. Veuillez rafraîchir la page et réessayer.');
    return;
  }

  var formData = {
    'items': [{
      'id': variantId,
      'selling_plan': sellingPlanId,
      'quantity': 1
    }]
  };

  // Clear cart first to avoid stale items from previous attempts
  fetch(window.Shopify.routes.root + 'cart/clear.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  })
  .then(function() {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    });
  })
  .then(function(response) {
    if (!response.ok) throw new Error('cart-add-failed');
    return response.json();
  })
  .then(function(data) {
    // Verify the item was added with the correct selling plan
    if (!data.items || data.items.length === 0) throw new Error('cart-add-failed');
    // FIX Bug#2b: verify cart is not empty before redirecting to checkout
    return fetch(window.Shopify.routes.root + 'cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (!cart.item_count || cart.item_count === 0) throw new Error('cart-empty-after-add');
        // Inject funnel tracking via cart note (optional — errors swallowed)
        var funnelSource = sessionStorage.getItem('funnel_source');
        if (funnelSource) {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: 'funnel_source=' + funnelSource })
          }).catch(function() {}); // Funnel tracking is optional — don't block checkout
        }
      });
  })
  .then(function() {
    // Bonus add-on (ex: bac inox from offer pages) + Pacha POD freebie (Portrait / Collier)
    // — re-add after main item, before checkout. Backward-compatible with existing bonus_variant.
    try {
      var qs = new URLSearchParams(window.location.search);
      var bonusId = qs.get('bonus_variant') ||
        (typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('plfb_bonus_variant') : null);

      var pachaFreebie = null;
      try {
        var raw = (typeof sessionStorage !== 'undefined') ? sessionStorage.getItem('pacha_freebie') : null;
        if (raw) pachaFreebie = JSON.parse(raw);
      } catch (e) { pachaFreebie = null; }

      if (!bonusId && !pachaFreebie) return;

      var items = [];
      if (bonusId) items.push({ id: parseInt(bonusId, 10), quantity: 1 });
      if (pachaFreebie && pachaFreebie.variant_id) {
        items.push({
          id: parseInt(pachaFreebie.variant_id, 10),
          quantity: 1,
          properties: pachaFreebie.properties || {}
        });
      }

      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(){
        try { sessionStorage.removeItem('plfb_bonus_variant'); } catch(e){}
        try { sessionStorage.removeItem('pacha_freebie'); } catch(e){}
      })
      .catch(function(){});
    } catch (e) { return; }
  })
  .then(function() {
    location.href = '/checkout';
  })
  .catch(function(error) {
    _checkoutInProgress = false;
    alert('Erreur lors de l\'ajout au panier. Veuillez rafraîchir la page et réessayer.');
  });
}

/**
 * checkout — called when user clicks "Paiement" button.
 * In v2, the popup is triggered on selectPlan('1mois') instead,
 * so this function goes straight to checkout.
 */
function checkout(popup_id) {
  doCheckout();
}

// =====================================================
//  V2 UI BEHAVIOR
// =====================================================

/**
 * selectCat — Step 1 cat card click
 */
function selectCat(n) {
  selectedCats = n;
  // Update visual selection on cat-option cards
  document.querySelectorAll('.v2-page-wrapper:not(.v2bis-page-wrapper) .cat-option').forEach(function(el, i) {
    el.classList.toggle('selected', i === n - 1);
  });
  // Also update the hidden .option active state for step 1
  var step1Options = document.querySelectorAll('.v2-page-wrapper:not(.v2bis-page-wrapper) .option[data-step="1"]');
  step1Options.forEach(function(el, i) {
    el.classList.toggle('active', i === n - 1);
  });
  updateCurrentSelectedOffer();
  updateDisplay();
}

/**
 * selectPlan — Step 2 plan card click.
 * Test #3: If user clicks 1mois when 3mois was selected, show popup after a short delay.
 */
var _suppressPopup = false; // FIX R2: flag to skip popup during deep link init

function selectPlan(plan) {
  if (plan === '1mois' && selectedPlan === '3mois') {
    selectedPlan = '1mois';
    applyPlanUI();
    // Update hidden .option for step 2
    syncStep2Option('1mois');
    updateCurrentSelectedOffer();
    // FIX R2: don't show popup when called from deep link (fromURL)
    if (!_suppressPopup) {
      setTimeout(function() { showPopup(); }, 350);
    }
    return;
  }
  selectedPlan = plan;
  applyPlanUI();
  syncStep2Option(plan);
  updateCurrentSelectedOffer();
}

function syncStep2Option(plan) {
  var step2Options = document.querySelectorAll('.v2-page-wrapper:not(.v2bis-page-wrapper) .option[data-step="2"]');
  step2Options.forEach(function(el) {
    if (el.dataset.combinaisonKey === plan) {
      el.classList.add('active');
    } else {
      el.classList.remove('active');
    }
  });
}

function applyPlanUI() {
  var plan3Card = document.getElementById('plan-3mois');
  var plan1Card = document.getElementById('plan-1mois');
  if (plan3Card) plan3Card.classList.toggle('selected', selectedPlan === '3mois');
  if (plan1Card) plan1Card.classList.toggle('selected', selectedPlan === '1mois');
}

function updateDisplay() {
  var d = catData[selectedCats];
  if (!d) return;

  var savingsTag = document.getElementById('savings-tag');
  var plan3Old = document.getElementById('plan3-price-old');
  var plan3New = document.getElementById('plan3-price-new');
  var plan3Detail = document.getElementById('plan3-detail');
  var plan3Footer = document.getElementById('plan3-footer');
  var plan1Price = document.getElementById('plan1-price');
  var plan1Detail = document.getElementById('plan1-detail');
  var popupDeliverySavings = document.getElementById('popup-delivery-savings');
  var step2Context = document.getElementById('step2-context');

  if (savingsTag) savingsTag.textContent = 'Risparmia ' + d.savings + '\u20AC';
  if (plan3Old) plan3Old.textContent = d.fullMonthly + '\u20AC';
  if (plan3New) plan3New.textContent = d.quarterly + '\u20AC';
  if (plan3Detail) plan3Detail.textContent = d.plan3Detail;
  if (plan3Footer) plan3Footer.textContent = d.savings + '\u20AC di risparmio';
  if (plan1Price) plan1Price.textContent = d.plan1Price;
  if (plan1Detail) plan1Detail.textContent = d.plan1Detail;
  if (popupDeliverySavings) popupDeliverySavings.textContent = '+ ' + d.savings + '\u20AC di risparmio a trimestre';

  var catLabel = selectedCats === 1 ? '1 gatto' : selectedCats + ' gatti';
  if (step2Context) step2Context.textContent = 'La tua offerta per ' + catLabel;

  // Per-cat/month cost — only show for 2+ cats
  var perCatEl = document.getElementById('plan3-per-cat');
  if (perCatEl) {
    if (selectedCats >= 2) {
      var perCat = (d.quarterly / 3 / selectedCats).toFixed(2).replace('.', ',');
      perCatEl.textContent = 'ovvero ~' + perCat + '\u20AC/gatto/mese';
      perCatEl.style.display = '';
    } else {
      perCatEl.style.display = 'none';
    }
  }
}

/**
 * goToStep — Navigate between steps.
 * When entering step 2, pre-select 3mois.
 */
function goToStep(step) {
  currentStep = step;
  document.querySelectorAll('.v2-page-wrapper:not(.v2bis-page-wrapper) .form-step').forEach(function(el) {
    el.classList.remove('active');
  });
  var target = document.getElementById('step-' + step);
  if (target) target.classList.add('active');

  // Update progress bar — FREEBIE OFFSET (+1):
  // The freebie progress bar has 4 dots. Form-step N maps to progress-step N+1
  // because progress-step 1 (Personnalisation) is always 'done' (no form,
  // completed upstream on the collier/portrait page).
  //   form-step=1 (Quantité)  → progress index 0 done, 1 active+done, 2-3 blank
  //   form-step=2 (Plan)      → progress indices 0,1 done, 2 active+done, 3 blank
  //   form-step=3 (Paiement)  → progress 0,1,2 done, 3 active+done (rare; usually checkout fires before this)
  document.querySelectorAll('.v2-page-wrapper:not(.v2bis-page-wrapper) .step-container').forEach(function(el, i) {
    el.classList.remove('active', 'done');
    if (i < step) el.classList.add('done');
    if (i === step) el.classList.add('active', 'done');
  });

  // Reset to 3mois when entering step 2
  if (step === 2) {
    selectedPlan = '3mois';
    applyPlanUI();
    syncStep2Option('3mois');
    // FIX Bug#1: reset actual radio buttons to match visual state
    // Without this, browser won't fire onchange when user clicks 1mois
    // because the radio may still be checked from a previous visit
    var radio3 = document.getElementById('plan-radio-3mois');
    var radio1 = document.getElementById('plan-radio-1mois');
    if (radio3) radio3.checked = true;
    if (radio1) radio1.checked = false;
    updateCurrentSelectedOffer();
    updateDisplay();
  }

  window.scrollTo({ top: 0, behavior: 'smooth' });
}

// =====================================================
//  DEEP LINKING (fromURL — preserved from original)
// =====================================================

function fromURL() {
  var queryString = window.location.search;
  var urlParams = new URLSearchParams(queryString);
  var step = urlParams.get('step');
  var step1_option = urlParams.get('step1_option');
  var step2_option = urlParams.get('step2_option');

  if (step != null) {
    goToStep(parseInt(step));
  }

  if (step1_option != null) {
    var idx = parseInt(step1_option);
    if (idx >= 1 && idx <= 3) {
      selectCat(idx);
    }
  }

  // FIX R2: suppress retention popup when plan is set via URL params
  if (step2_option != null) {
    _suppressPopup = true;
    if (step2_option === '1' || step2_option === '1mois') {
      selectPlan('1mois');
    } else if (step2_option === '2' || step2_option === '3mois') {
      selectPlan('3mois');
    }
    _suppressPopup = false;
  }
}

// =====================================================
//  FAQ
// =====================================================

function toggleFaq(btn) {
  var item = btn.closest('.faq-item');
  item.classList.toggle('open');
  var isOpen = item.classList.contains('open');
  btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
}

// =====================================================
//  REVIEWS CAROUSEL
// =====================================================

var reviewTrack, reviewCards, dotsContainer;
var currentReview = 0;
var reviewTimer;

function initReviews() {
  reviewTrack = document.getElementById('reviews-track');
  dotsContainer = document.getElementById('review-dots');
  if (!reviewTrack || !dotsContainer) return;
  reviewCards = reviewTrack.children;

  // Build dots
  for (var i = 0; i < reviewCards.length; i++) {
    var dot = document.createElement('span');
    dot.className = 'review-dot' + (i === 0 ? ' active' : '');
    (function(idx) {
      dot.onclick = function() { goToReview(idx); };
    })(i);
    dotsContainer.appendChild(dot);
  }

  resetReviewTimer();
}

function goToReview(index) {
  currentReview = index;
  if (reviewTrack) {
    reviewTrack.style.transform = 'translateX(-' + (index * 100) + '%)';
  }
  if (dotsContainer) {
    dotsContainer.querySelectorAll('.review-dot').forEach(function(d, i) {
      d.classList.toggle('active', i === index);
    });
  }
  resetReviewTimer();
}

function reviewNav(dir) {
  if (!reviewCards) return;
  var next = currentReview + dir;
  if (next < 0) next = reviewCards.length - 1;
  if (next >= reviewCards.length) next = 0;
  goToReview(next);
}

function resetReviewTimer() {
  clearInterval(reviewTimer);
  reviewTimer = setInterval(function() {
    reviewNav(1);
  }, 5000);
}

// =====================================================
//  STICKY CTA
// =====================================================

function initStickyCta() {
  var stickyCta = document.getElementById('v2-sticky-cta');
  var formCard = document.querySelector('.v2-page-wrapper:not(.v2bis-page-wrapper) .form-card');
  if (!stickyCta || !formCard) return;

  window.addEventListener('scroll', function() {
    var formBottom = formCard.getBoundingClientRect().bottom;
    stickyCta.classList.toggle('visible', formBottom < 0);
  });
}

// =====================================================
//  INITIALIZATION
// =====================================================

function initV2Form() {
  // Set step 1 cat option 1 as active (default)
  var step1Options = document.querySelectorAll('.v2-page-wrapper:not(.v2bis-page-wrapper) .option[data-step="1"]');
  if (step1Options.length > 0) step1Options[0].classList.add('active');

  // Set step 2 3mois option as active (pre-selected)
  var step2Options = document.querySelectorAll('.v2-page-wrapper:not(.v2bis-page-wrapper) .option[data-step="2"]');
  step2Options.forEach(function(el) {
    if (el.dataset.combinaisonKey === '3mois') {
      el.classList.add('active');
    }
  });

  // Set first cat-option card as selected
  var catOptions = document.querySelectorAll('.v2-page-wrapper:not(.v2bis-page-wrapper) .cat-option');
  if (catOptions.length > 0) catOptions[0].classList.add('selected');

  // Update combinaison
  updateCurrentSelectedOffer();

  // Update display with default cat count
  updateDisplay();

  // Apply plan UI (3mois pre-selected)
  applyPlanUI();

  // Init sub-features
  initReviews();
  initStickyCta();

  // Deep linking
  fromURL();
}

// Run when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initV2Form);
} else {
  initV2Form();
}
